import { render } from "./iconDiscord.svg?vue&type=template&id=e40ba40c"
const script = {}

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__